var _defs, _use;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "close-a",
    d: "M37.45766,2.54233997 C38.18078,3.26545992 38.18078,4.43786902 37.45766,5.16098897 L22.618,20 L37.45766,34.839011 C38.18078,35.562131 38.18078,36.7345401 37.45766,37.45766 C36.7345401,38.18078 35.562131,38.18078 34.839011,37.45766 L20,22.618 L5.16098897,37.45766 C4.43786902,38.18078 3.26545992,38.18078 2.54233997,37.45766 C1.81922001,36.7345401 1.81922001,35.562131 2.54233997,34.839011 L17.382,20 L2.54233997,5.16098897 C1.81922001,4.43786902 1.81922001,3.26545992 2.54233997,2.54233997 C3.26545992,1.81922001 4.43786902,1.81922001 5.16098897,2.54233997 L20,17.382 L34.839011,2.54233997 C35.562131,1.81922001 36.7345401,1.81922001 37.45766,2.54233997 Z"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "#4E4848",
    fillRule: "evenodd",
    xlinkHref: "#close-a"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.8b36affe8b56b858be33dbcd92326a09.svg";
export { ForwardRef as ReactComponent };